import { IResumeProps } from "./types";

export function Resume({REP_BUILD_DATA,infocusID, VGV_IN_TEXT}: IResumeProps) {

    return (
         <div data-infocusID={infocusID === 14}
                className="md:absolute
                    print:!relative
                    print:!left-0
                    border-[1px] border-r-[#000]
                    last-of-type:border-none
                    opacity-100 -left-[100%]
                    data-[inFocusID=true]:opacity-0
                    data-[inFocusID=true]:left-0
                    transition-all duration-[0.38s]
                    w-full h-screen flex flex-col justify-between gap-4 p-16 bg-white
                    page-break
                "
            >
                <div className="w-[60%] flex flex-col justify-between gap-16 py-16">
                    <span className="w-full h-auto flex flex-col gap-4">
                        <span className="text-5xl">Resumo do produto</span>
                        <span className="text-5xl font-bold">imobiliário ideal e indicador</span>
                    </span>
                </div>
                <span className="w-full flex-1 flex flex-row flex-wrap gap-12">
                    <span className="min-w-[25%] z-[999] max-w-[50%] h-24 flex flex-row gap-2">
                        <span className="w-1/4 h-full bg-[#079269] text-xl font-bold text-white flex flex-row items-center justify-center">
                            FIP
                        </span>
                        <span className="flex-1 flex flex-col items-start gap-4">
                            <span className="text-md font-semibold">Faixa de venda do imóvel performado</span>
                            <span className="text-gray-400 font-normal flex gap-2">
                                Entre
                                <span>
                                    {VGV_IN_TEXT.split(', ')[0]}
                                </span>
                                <span>
                                    á
                                </span>
                                <span>
                                    {VGV_IN_TEXT.split(', ')[2]}
                                </span>
                            </span>
                        </span>
                    </span>

                    <span className="w-[25%] h-24 flex flex-row gap-2">
                        <span className="w-1/4 h-full bg-[#079269] text-xl font-bold text-white flex flex-row items-center justify-center">
                            VT
                        </span>
                        <span className="flex-1 flex flex-col items-start gap-4">
                            <span className="text-md font-semibold">Valor médio do terreno/m²</span>
                            <span className="text-gray-400 font-normal flex gap-2">
                                DADOS DE TERRENO DO(S) LOTE(S)
                            </span>
                        </span>
                    </span>

                    <span className="w-[25%] h-24 flex flex-row gap-2">
                        <span className="w-1/4 h-full bg-[#079269] text-xl font-bold text-white flex flex-row items-center justify-center">
                            VI
                        </span>
                        <span className="flex-1 flex flex-col items-start gap-4">
                            <span className="text-md font-semibold">Valor médio de venda do imóvel por m²</span>
                            <span className="text-gray-400 font-normal flex gap-2">
                                {
                                    REP_BUILD_DATA?.AMOUNT_BY_METERS || ''
                                }/m²
                            </span>
                        </span>
                    </span>

                    <span className="w-[25%] z-[999] h-24 flex flex-row gap-2">
                        <span className="w-1/4 h-full bg-[#079269] text-xl font-bold text-white flex flex-row items-center justify-center">
                            AT
                        </span>
                        <span className="flex-1 flex flex-col items-start gap-4">
                            <span className="text-md font-semibold">Área do terreno</span>
                            <span className="text-gray-400 font-normal flex gap-2">
                                {
                                    REP_BUILD_DATA?.idealArea || ''
                                }/m²
                            </span>
                        </span>
                    </span>

                    <span className="w-[25%] h-24 flex flex-row gap-2">
                        <span className="w-1/4 h-full bg-[#079269] text-xl font-bold text-white flex flex-row items-center justify-center">
                            AC
                        </span>
                        <span className="flex-1 flex flex-col items-start gap-4">
                            <span className="text-md font-semibold">Área construída</span>
                            <span className="text-gray-400 font-normal flex gap-2">
                                {
                                    REP_BUILD_DATA?.idealAreaBuild || ''
                                }/m²
                            </span>
                        </span>
                    </span>
                </span>
            </div>
    )
}
